// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "organization_location".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { countryCodeValues } from '@borradh-workspace/labels';
/** Response atom for the "organization_location" table (1:1 with a DB row, on the wire). */
export const organizationLocationAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    phone: z.string().nullable(),
    name: z.string().nullable(),
    addressLine1: z.string(),
    addressLine2: z.string().nullable(),
    city: z.string(),
    county: z.string().nullable(),
    postalCode: z.string().nullable(),
    country: z.enum(countryCodeValues),
    latitude: z.number().nullable(),
    longitude: z.number().nullable(),
    googlePlaceId: z.string().nullable(),
    openingHours: z.unknown().nullable(),
    stripeTerminalLocationId: z.string().nullable(),
    slug: z.string(),
    about: z.string().nullable(),
    amenities: z.unknown(),
    isPrimary: z.boolean(),
    sortOrder: z.number(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=organizationLocation.js.map